export const TABSBox = [
  "معرفی موسسه",
  "مدارک سازمانی",
  "راه‌های ارتباطی",
  "گالری",
  "دیدگاه کاربران",
];

export const TABSInfo = [
  "درباه ما",
  "چشم انداز",
  "شعب و محدوده فعالیت",
  "اعضای سازمان",
  "ساعات کاری",
];

export const TABSGallery = ["تصاویر", "ویدئو"];

export const TABSComments = [
  "دیدگاه کاربران",
  "ثبت دیدگاه",
  "امتیاز کاربران",
  "ثبت امتیاز",
];
